(function () {
  const easeOutExpo = (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t));

  const animateNumber = (element, target, duration = 2500) => {
    const start = 0;
    const startTime = performance.now();
    element.classList.add('animating');

    // choose the node to update once
    const unitElement = element.querySelector('.data-banner__unit');
    let textNode;
    if (unitElement) {
      textNode = element.firstChild && element.firstChild.nodeType === Node.TEXT_NODE
        ? element.firstChild
        : null;
      if (!textNode) {
        textNode = document.createTextNode('0');
        element.insertBefore(textNode, unitElement);
      }
    }

    const updateNumber = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeOutExpo(progress);
      const current = Math.round(start + (target - start) * eased);

      if (textNode) {
        textNode.textContent = current;
      } else {
        element.textContent = current;
      }

      if (progress < 1) {
        requestAnimationFrame(updateNumber);
      } else {
        if (textNode) {
          textNode.textContent = target;
        } else {
          element.textContent = target;
        }
        setTimeout(() => {
          element.classList.add('complete');
          element.classList.remove('animating');
        }, 100);
      }
    };

    requestAnimationFrame(updateNumber);
  };

  const initDataBanner = (section) => {
    if (!section || !section.classList.contains('data-banner-section')) return;

    const dataBanner = section.querySelector('.data-banner');
    if (!dataBanner) return;

    const items = dataBanner.querySelectorAll('.data-banner__item');
    const numberElements = dataBanner.querySelectorAll('.data-banner__number');
    const ctaElement = dataBanner.querySelector('.data-banner__cta');

    if (!numberElements || numberElements.length === 0) return;

    let animated = false;
    const targetNumbers = new Array(numberElements.length);

    // initialize numbers and collect targets
    for (let i = 0; i < numberElements.length; i++) {
      const numberEl = numberElements[i];
      const fullText = numberEl.textContent.trim();
      const match = fullText.match(/^\d+/);
      if (match) {
        targetNumbers[i] = parseInt(match[0], 10);
        const unitElement = numberEl.querySelector('.data-banner__unit');
        if (unitElement) {
          const textNode = numberEl.firstChild && numberEl.firstChild.nodeType === Node.TEXT_NODE
            ? numberEl.firstChild
            : null;
          if (textNode) textNode.textContent = '0';
          else numberEl.insertBefore(document.createTextNode('0'), unitElement);
        } else {
          numberEl.textContent = '0';
        }
      }
    }

    let observer;
    const observerCallback = (entries) => {
      for (let i = 0; i < entries.length; i++) {
        const entry = entries[i];
        if (entry.isIntersecting && !animated) {
          animated = true;

          // stagger item animations
          for (let j = 0; j < items.length; j++) {
            ((idx) => {
              setTimeout(() => {
                items[idx].classList.add('animate-in');
              }, idx * 200);
            })(j);
          }

          // stagger number animations (slightly delayed)
          for (let k = 0; k < numberElements.length; k++) {
            if (targetNumbers[k]) {
              ((idx) => {
                setTimeout(() => {
                  animateNumber(numberElements[idx], targetNumbers[idx], 2500);
                }, idx * 200 + 300);
              })(k);
            }
          }

          // stop observing the banner that triggered animation
          if (observer) observer.unobserve(entry.target);
          break;
        }
      }
    };

    observer = new IntersectionObserver(observerCallback, {
      threshold: 0.2,
      rootMargin: '0px 0px -20% 0px',
    });

    observer.observe(dataBanner);
  };

  initDataBanner(document.currentScript && document.currentScript.parentElement);

  document.addEventListener('shopify:section:load', function (event) {
    initDataBanner(event.target);
  }, { passive: true });
})();
